import { ArrowButton } from '../../shared/ui';

export interface IControlButtonsAndDots {
  currentPage: number;
  totalPages: number;
  handlePrev: () => void;
  jumpto: (index: number) => void;
  handleNext: () => void;
}

export const ControlButtonsAndDots = ({
  currentPage,
  totalPages,
  handlePrev,
  jumpto,
  handleNext,
}: IControlButtonsAndDots) => {
  return (
    <div className="flex items-center justify-center mt-auto space-x-4 mb-4">
      <ArrowButton
        direction="prev"
        size="md"
        tone="solid"
        label="Предыдущая страница"
        disabled={currentPage === 0}
        onClick={handlePrev}
      />

      {/* Pagination Dots */}
      <div className="flex gap-5">
        {totalPages > 1 &&
          Array.from({ length: totalPages }).map((_, index) => (
            <div
              key={index}
              className={`w-4 h-4 rounded-full transition-transform duration-500 ${
                index === currentPage ? 'bg-ink-muted scale-[1.5]' : 'bg-line-strong'
              } cursor-pointer`}
              onClick={() => {
                jumpto(index);
              }}
            ></div>
          ))}
      </div>

      <ArrowButton
        direction="next"
        size="md"
        tone="solid"
        label="Следующая страница"
        disabled={currentPage === totalPages - 1}
        onClick={handleNext}
      />
    </div>
  );
};
